var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_sync"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password",
      "name": "fake_password",
      "autocomplete": "current-password",
      "tabindex": "-1"
    }
  }), _c('Alert', [_c('div', [_vm._v($t("j28yrss", "说明：通过手机号检索应用内账号，如果手机号相同自动关联。"))]), _c('div', [_vm._v($t("umti3et", "通过姓名检索应用账号，姓名相同自动关联，重名账号不自动关联"))]), _c('div', [_vm._v($t("nv9f4q", "单位是按照iWork单位对照 PMS GC单位创建。"))]), _c('div', [_vm._v($t("z8nhw0k", "无账号则自动创建账号按照下面规则创建账号"))])]), _c('pro-form', {
    ref: "proForm",
    attrs: {
      "label-width": "130",
      "label-position": "right",
      "columns": _vm.columns
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };